module.exports = __webpack_public_path__ + "static/media/17IT125.f59c6715.JPG";